<template>
    <div class="process-report-list">
        <el-tabs :tab-position="tabPosition" v-model="tabName"  @tab-click="handleTabClick" type="border-card" class="business-report-tree-card">
            <!-- 报表信息 -->
            <el-tab-pane v-for="(item, index) in reports" :key="'report'+index" :name="'report'+index" :label="item.formName">
                <ReportRelateTree :ref="'report'+index" :key="'report'+index" :processInstanceId="item.processInstanceId" :modelId="item.modelId" :formId="item.formId" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import ReportRelateTree from '@/components/ReportRelateTree';
    export default {
        components: {
            ReportRelateTree
        },
        data () {
            return {
                tabName: '',
                tabPosition: 'top',
                isShowFormAuthConfig: 'false',
                loadTimer: ''
            };
        },
        props: {
            reports: {
                type: Array,
                default: () => []
            }
        },
        created () {
        },
        computed: {
        },
        methods: {
            async _initPage () {
                this.tabName = 'report0';
                // console.log(this.$refs['report0']);
                setTimeout(() => {
                    this.$refs['report0'][0]._initPage();
                }, 0);
            },
            async handleTabClick (tab, event) {
                // console.log(tab.index);
                setTimeout(() => {
                    this.$refs['report' + tab.index][0]._initPage();
                }, 0);
            }
        }
    };
</script>

<style lang="less">
    // .process-report-tree{
    //    .process-report-list {
    //        margin-top: -25px;
    //        height: ~"calc(100% - 7vh)";
    //        position: absolute;
    //        width: 98%;
    //        .el-tabs__content{
    //            height:100%;
    //            .el-tab-pane{
    //                height:100%;
    //            }
    //        }
    //        .tab-list{
    //            height: ~'calc(100% - 16vh)';
    //        }
    //    }
    // }
    .business-report-tree{
        .process-report-list{
            height: 100%;
            overflow: auto;
            .business-report-tree-card {
                height: 99%;
                .el-tabs__content{
                    height: ~'calc(100% - 12vh)';
                    .el-tab-pane{
                        height: ~'calc(100% - 2vh)';
                        // .report-relate{
                        //    height: ~'calc(100% - 2vh)';
                        //    width: 100%;
                        // }
                    }
                }
            }
            // .el-tabs{
            //     // height: ~'calc(100% - 2vh)';

            // }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/MyProcess/ProcessReportList.vue